import styled from '@emotion/styled';

export const gaps = {
  'xs': '5px',
  'sm': '10px',
  'md': '20px',
  'lg': '30px',
  'xl': '40px',
  '2xl': '50px',
};

const Stack = styled.div`
  display: flex;
  flex-direction: ${props => props.inline ? 'row' : 'column'};
  align-items: ${props => props.alignItems ?? 'flex-start'};
  justify-content: ${props => props.justifyContent ?? 'flex-start'};
  gap: ${props => gaps[props.gap]};

  & > * {
    margin: 0 !important;
  }
`;

export default Stack;